<template>

	<div>
		<div class="md-layout">
			<entity-card v-bind="{ schema, readEntity, deleteEntity, createEntity, updateEntity }" :entity.sync="entity"></entity-card>
		</div>

		<div class="md-layout" v-if="entity.id !== 'novo'">
			<md-card class="md-layout-item md-size-100">
				<md-card-header class="md-card-header-text md-card-header-accent">
					<div class="card-text">
						<h4 class="title">Módulos</h4>
					</div>
				</md-card-header>

				<md-card-content>
					<md-table :value="modules" class="paginated-table table-striped table-hover">
						<md-table-toolbar>
							<div class="md-layout">
								<div class="md-layout-item" style="text-align: right">
									<md-button class="md-accent" style="margin: 5px" @click="$router.push(`/artigos/novo/${entity.id}`)">Adicionar</md-button>
								</div>
							</div>
						</md-table-toolbar>

						<md-table-row slot="md-table-row" style="cursor: pointer">
							<md-table-head>Nome</md-table-head>
						</md-table-row>

						<md-table-row v-for="(field, fieldIndex) in modules" :key="fieldIndex" :md-sort-by="field.name" slot="md-table-row" @click="$router.push(`/artigos/${field.id}`)" style="cursor: pointer">
							<md-table-cell :md-label="field.name">{{field.name}}</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout" v-if="entity.id !== 'novo'">
			<md-card class="md-layout-item md-size-100">
				<md-card-header class="md-card-header-text md-card-header-accent">
					<div class="card-text">
						<h4 class="title">Reviews</h4>
					</div>
				</md-card-header>

				<md-card-content>
					<md-table :value="reviews" class="paginated-table table-striped table-hover">
						<md-table-row slot="md-table-row">
							<md-table-head>Avaliação</md-table-head>
							<md-table-head>Comentário</md-table-head>
							<md-table-head>Usuário</md-table-head>
						</md-table-row>

						<md-table-row v-for="(field, fieldIndex) in reviews" :key="fieldIndex" slot="md-table-row" style="cursor: pointer">
							<md-table-cell>{{field.rating}}</md-table-cell>
							<md-table-cell>{{field.comment}}</md-table-cell>
							<md-table-cell>{{field.user.name}}</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
			</md-card>
		</div>
	</div>

</template>

<script>
	import Course from "@/models/course.model.vue"
	import EntityCard from "@/components/Espresso/EntityCard.vue"

	export default {
		components: {
			EntityCard,
		},
		data() {
			return {
				entity: {
					id: this.$route.params.id,
				},
				schema: Course.getSchema(),
				modules: [],
				reviews: [],
			}
		},
		methods: {
			async createEntity(entity) {
				this.entity = await Course.create(entity);
				// await Product.reloadCategories();
				this.$router.replace(`/cursos/${this.entity.id}`);
				return this.entity;
			},
			async readEntity(entityId) {
				return Course.getInfo(entityId);
			},
			async updateEntity(entity) {
				const dataToUpdate = Object.assign({}, entity);
				return Course.updateInfo(dataToUpdate);
			},
			async deleteEntity(entityId) {
				await Course.remove(entityId);
				this.$router.push("/cursos");
			},
			async getModules() {
				this.modules = await Course.getModules(this.entity.id);
			},
			async getReviews() {
				const response = await Course.listReviews(this.entity.id);
				this.reviews = response.results;
			}
		},
		created() {
			if (this.entity.id !== "novo") {
				this.getModules();
				this.getReviews();
			}
		}
	};
</script>
